import React, { useRef } from 'react';
import { Grid } from '@mui/material';
import { jsPDF } from 'jspdf';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import { formatDate, toDateFromParts } from 'utils/formatters';
import PdfHeader from 'components/PdfHeader';
import boxShadows from 'assets/theme/base/boxShadows';
import { formatDateTimeARG } from 'utils/formatters';
import { formatMoneyPunto } from 'utils/formatters';

const EntregaPDF = ({ data, onGeneratePdf }) => {
    const documentsRef = useRef(null);
    const { lg } = boxShadows;

    const handleGeneratePdf = async () => {
        if (!data) return;

        const document = documentsRef.current.childNodes[0];
        const doc = new jsPDF({
            format: 'a4',
            unit: 'px',
            orientation: 'portrait',
            hotfixes: ['px_scaling'],
            compress: true,
        });

        await doc.html(document, {
            margin: [40, 0, 40, 0],
            callback(pdf) {
                pdf.save(`Resumen carga de saldos.pdf`);
                if (onGeneratePdf) onGeneratePdf();
            },
        });
    };

    React.useEffect(() => {
        if (data && typeof data === 'object') {
            handleGeneratePdf();
        }
    }, [data]);

    if (!data) return null;

    return (
        <SoftBox
            p={2}
            display='flex'
            alignItems='center'
            flexDirection='column'
            minHeight='100vh'
            height='100%'
            gap={4}
            style={{ position: 'absolute', left: '-9999px', top: '-9999px' }}
        >
            <div ref={documentsRef}>
                <SoftBox
                    sx={{
                        position: 'relative',
                        overflow: 'hidden',
                        width: '794px',
                        backgroundColor: '#ffffff',
                        boxShadow: lg,
                        px: 6,
                    }}
                    pb={5}
                >
                    <PdfHeader />

                    <SoftBox
                        mt={4}
                        display='flex'
                        flexDirection='column'
                        gap={2}
                        lineHeight={1.7}
                        fontSize='12px'
                    >
                        <SoftTypography variant='body2' fontWeight='bold' textAlign='center'>Carga de saldos a clientes</SoftTypography>

                        <Grid
                            container
                            border='1pt solid black'
                            lineHeight={1.5}
                            sx={{ '& > *:not(:last-child)': { borderBottom: '1pt solid black' } }}
                        >
                            <Grid item xs={12} backgroundColor='#f0f0f0' fontWeight='bold' px={1}>
                                DETALLE
                            </Grid>

                            <Grid item xs={4} borderRight='1pt solid black' backgroundColor='#f0f0f0' fontWeight='bold' px={1}>
                                Fecha
                            </Grid>
                            <Grid item xs={8} px={1}>
                                {formatDateTimeARG(data?.fechaPago)}
                            </Grid>

                            <Grid item xs={4} borderRight='1pt solid black' backgroundColor='#f0f0f0' fontWeight='bold' px={1}>
                                Tipo
                            </Grid>
                            <Grid item xs={8} px={1}>
                                {data?.tipoCarga ?? '-'}
                            </Grid>

                            <Grid item xs={4} borderRight='1pt solid black' backgroundColor='#f0f0f0' fontWeight='bold' px={1}>
                                Cantidad de clientes alcanzados
                            </Grid>
                            <Grid item xs={8} px={1}>
                                {data?.pagos?.length ?? '0'}
                            </Grid>
                            <Grid item xs={4} borderRight='1pt solid black' backgroundColor='#f0f0f0' fontWeight='bold' px={1}>
                                Monto por cliente
                            </Grid>
                            <Grid item xs={8} px={1}>
                                $&nbsp;{formatMoneyPunto(data?.totalPago)}
                            </Grid>
                            <Grid item xs={4} borderRight='1pt solid black' backgroundColor='#f0f0f0' fontWeight='bold' px={1}>
                                Monto total cargado
                            </Grid>
                            <Grid item xs={8} px={1}>
                                $&nbsp;{formatMoneyPunto((data?.pagos?.length || 1) * (data?.totalPago || 0))}
                            </Grid>
                        </Grid>

                        <Grid
                            container
                            border='1pt solid black'
                            sx={{
                                '& > .MuiGrid-item:not(:last-child)': { borderBottom: '1pt solid black' }
                            }}
                        >
                            <Grid item xs={12} backgroundColor='#f0f0f0' fontWeight='bold' px={1}>
                                Clientes
                            </Grid>

                            <Grid
                                item
                                container
                                xs={12}
                                backgroundColor='#f0f0f0'
                                fontWeight='bold'
                                sx={{ '& > *:not(:last-child)': { borderRight: '1pt solid black' } }}
                            >
                                <Grid item xs={3} px={3} pl={2} textAlign="center" fontSize='10px'>
                                    DNI
                                </Grid>
                                <Grid item xs={4.5} px={0.5} pl={2} textAlign="center" fontSize='10px'>
                                    Apellido
                                </Grid>
                                <Grid item xs={4.5} px={0.5} pl={2} textAlign="center" fontSize='10px'>
                                    Nombre
                                </Grid>
                            </Grid>

                            {data?.pagos?.length > 0 ? (
                                data.pagos.map(({cliente}, index) => (
                                    <Grid
                                        key={index}
                                        item
                                        container
                                        xs={12}
                                        lineHeight={1.5}
                                        sx={{ '& > *:not(:last-child)': { borderRight: '1pt solid black' } }}
                                    >
                                        <Grid item xs={3} px={0.5} pl={2} fontSize='10px'>
                                            {formatMoneyPunto(cliente?.dni) || 'N/A'}
                                        </Grid>
                                        <Grid item xs={4.5} px={0.5} pl={2} fontSize='10px'>
                                            {cliente?.apellido || 'N/A'}
                                        </Grid>
                                        <Grid item xs={4.5} px={0.5} pl={2} fontSize='10px'>
                                            {cliente?.nombre ?? '-'}
                                        </Grid>
                                    </Grid>
                                ))
                            ) : (
                                <Grid item xs={12} px={1} py={2} textAlign='center'>
                                    No se registran clientes.
                                </Grid>
                            )}
                        </Grid>

                        {/* <SoftTypography variant='text' textAlign='center' display='block' mt={2}>
                            Este documento se genero el {formatDate(new Date(), 'dd/MM/yyyy hh:mm')} hs. por {data.user?.nombre || 'N/A'} {data.user?.apellido || ''} ({data.user?.email || 'N/A'}).
                        </SoftTypography> */}
                    </SoftBox>
                </SoftBox>
            </div>
        </SoftBox>
    );
};

export default EntregaPDF;




